import React, { useState, useEffect } from 'react';
import '../assets/css/signin-modal.css';

function SignInModal({
  open,
  onClose,
  title = 'Sign In',
  message,
  authEmail,
  setAuthEmail,
  authLoading,
  authMessage,
  onEmailSignIn,
  onGoogleSignIn,
  onEmailPasswordSignIn,
  onEmailPasswordSignUp,
}) {
  const [isSignUp, setIsSignUp] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (open) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [open]);

  const handlePasswordAuth = (e) => {
    e.preventDefault();
    setPasswordError('');
    
    if (isSignUp) {
      if (password.length < 6) {
        setPasswordError('Password must be at least 6 characters');
        return;
      }
      if (password !== confirmPassword) {
        setPasswordError('Passwords do not match');
        return;
      }
      onEmailPasswordSignUp?.(authEmail, password);
    } else {
      onEmailPasswordSignIn?.(authEmail, password);
    }
  };

  const toggleMode = () => {
    setIsSignUp(!isSignUp);
    setPassword('');
    setConfirmPassword('');
    setPasswordError('');
  };

  if (!open) return null;

  return (
    <div
      className={`signin-modal-overlay ${showModal ? 'show' : ''}`}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(5px)',
        zIndex: 10001,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        
        
      }}
      onClick={onClose}
    >
      <div
        className="signin-modal"
        style={{
          background: '#fff',
          borderRadius: '0px',
          padding: '40px',
          width: '600px',
          height: '100vh',
          boxShadow: 'none',
          textAlign: 'left',
          position: 'relative',
          border: 'none',
          boxSizing: 'border-box',
          paddingTop: '100px',
          paddingLeft: '70px',
          paddingRight: '70px'
          
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: '#f0f0f0',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer',
            color: '#333',
            width: '30px',
            height: '30px',
            borderRadius: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#e0e0e0';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f0f0f0';
          }}
        >
          ✕
        </button>

        <h2
          style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#000',
            margin: '40px 0 8px 0',
            letterSpacing: '-0.5px',
          }}
        >
          LOGIN
        </h2>

        <p
          style={{
            fontSize: '14px',
            color: '#666',
            margin: '0 0 24px 0',
            lineHeight: '1.5',
            fontWeight: '400',
          }}
        >
          Log in to your account to access your profile info, favorite products, brands and Fashion Board.
        </p>

        <form onSubmit={handlePasswordAuth} style={{ marginBottom: '20px' }}>
          <input
            type="email"
            placeholder="Email address"
            value={authEmail}
            onChange={(e) => setAuthEmail(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #ddd',
              borderRadius: '0px',
              fontSize: '14px',
              outline: 'none',
              background: '#fff',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              marginBottom: '16px',
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = '#000';
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = '#ddd';
            }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #ddd',
              borderRadius: '0px',
              fontSize: '14px',
              outline: 'none',
              background: '#fff',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              marginBottom: '16px',
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = '#000';
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = '#ddd';
            }}
          />
          {isSignUp && (
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '1px solid #ddd',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                background: '#fff',
                transition: 'all 0.2s',
                boxSizing: 'border-box',
                marginBottom: '16px',
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = '#000';
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = '#ddd';
              }}
            />
          )}
          {passwordError && (
            <p style={{ fontSize: '12px', color: '#c0392b', margin: '0 0 16px 0', textAlign: 'left', paddingLeft: '8px' }}>
              {passwordError}
            </p>
          )}
          
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            <input
              type="checkbox"
              id="remember"
              style={{
                marginRight: '8px',
                width: '14px',
                height: '14px',
              }}
            />
            <label htmlFor="remember" style={{ color: '#666', cursor: 'pointer' }}>
              Remember Me
            </label>
          </div>
          
          <button
            type="submit"
            disabled={authLoading || !authEmail || !password}
            style={{
              width: '100%',
              padding: '14px 24px',
              background: '#000',
              border: 'none',
              borderRadius: '0px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#fff',
              cursor: authLoading || !authEmail || !password ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              letterSpacing: '0.5px',
              marginBottom: '16px',
            }}
          >
            {authLoading ? 'Please wait...' : 'LOGIN'}
          </button>
          
          <div style={{ textAlign: 'right' }}>
            <button
              type="button"
              style={{
                background: 'none',
                border: 'none',
                fontSize: '12px',
                color: '#666',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: 0,
              }}
            >
              Lost your password?
            </button>
          </div>
        </form>

        {authMessage && (
          <p
            style={{
              fontSize: '13px',
              color: authMessage.includes('Error') ? '#c0392b' : '#27ae60',
              margin: '0 0 16px 0',
              padding: '12px',
              background: authMessage.includes('Error')
                ? 'rgba(192, 57, 43, 0.06)'
                : 'rgba(39, 174, 96, 0.06)',
              borderRadius: '4px',
              fontWeight: '300',
            }}
          >
            {authMessage}
          </p>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: '0 0 20px 0',
            gap: '16px',
          }}
        >
          <div style={{ flex: 1, height: '1px', background: '#f0f0f0' }} />
          <span
            style={{
              fontSize: '11px',
              color: '#bbb',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            or
          </span>
          <div style={{ flex: 1, height: '1px', background: '#f0f0f0' }} />
        </div>

        <button
          onClick={onGoogleSignIn}
          type="button"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            width: '100%',
            padding: '14px 24px',
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '0px',
            fontSize: '13px',
            fontWeight: '400',
            color: '#1a1a1a',
            cursor: 'pointer',
            transition: 'all 0.2s',
            letterSpacing: '0.3px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#1a1a1a';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#e0e0e0';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </button>

        <p
          style={{
            fontSize: '11px',
            color: '#bbb',
            marginTop: '28px',
            lineHeight: '1.5',
            fontWeight: '300',
          }}
        >
          By continuing, you agree to our Terms & Privacy Policy
        </p>
      </div>
    </div>
  );
}

export default SignInModal;
